import { Box, Grid, Skeleton } from '@mui/material';
import _ from 'lodash';
import { ProviderInfoSkeleton } from '../../components/provider-info/ProviderInfoSkeleton';

export const CourseDetailPageSkeleton: React.FC = () => {
  return (
    <Box className="container-fluid" sx={{ py: 5 }}>
      <Box>
        <Skeleton width="10rem" />
        <Skeleton sx={{ mt: 1 }} variant="rectangular" height="3rem" width="clamp(15rem, 25rem, 100%)" />
      </Box>
      <Box sx={{ mt: 3, p: 3, boxShadow: 10, borderRadius: '0.25rem' }}>
        <Grid container spacing={2.5}>
          {_.times(4, (index) => (
            <Grid item key={index} xs={12} sm={6} lg={3}>
              <Grid container flexWrap="nowrap" spacing={2}>
                <Grid item>
                  <Skeleton variant="circular" height="1.25rem" width="1.25rem" />
                </Grid>
                <Grid item xs>
                  <Skeleton variant="text" height="1.375rem" width="75%" />
                  <Skeleton variant="text" height="1.125rem" width="50%" />
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box sx={{ mt: 7.5 }}>
        <Grid container alignItems="flex-end" spacing={2.5}>
          <Grid item xs={12} lg={4}>
            <Skeleton sx={{ mb: 3 }} variant="rectangular" height="2rem" width="clamp(15rem, 25rem, 100%)" />
            <Box sx={{ mb: 2 }}>
              <Grid container flexWrap="nowrap" spacing={2}>
                <Grid item>
                  <Skeleton variant="circular" height="1.25rem" width="1.25rem" />
                </Grid>
                <Grid item xs>
                  <Skeleton variant="text" height="1.25rem" width="clamp(10rem, 20rem, 75%)" />
                </Grid>
              </Grid>
            </Box>
            <Box sx={{ mb: 2 }}>
              <Grid container flexWrap="nowrap" spacing={2}>
                <Grid item>
                  <Skeleton variant="circular" height="1.25rem" width="1.25rem" />
                </Grid>
                <Grid item xs>
                  <Skeleton variant="text" height="1.25rem" width="clamp(10rem, 20rem, 75%)" />
                  <Skeleton variant="text" height="1.25rem" width="clamp(10rem, 20rem, 75%)" />
                </Grid>
              </Grid>
            </Box>
            <Grid container spacing={2.5}>
              <Grid item>
                <Skeleton width="clamp(10rem, 20rem, 30rem)" variant="rectangular" height="3rem" />
              </Grid>
              <Grid item>
                <Skeleton variant="circular" width="3rem" height="3rem" />
              </Grid>
            </Grid>
            <Box sx={{ mt: 1.5 }}>
              <Skeleton width="10rem" />
            </Box>
          </Grid>

          <Grid item xs={12} lg={8}>
            <ProviderInfoSkeleton />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
